import { atom } from 'recoil';

// Campaign configuration from API
export const businessGiftCampaignState = atom({
    key: 'businessGiftCampaign',
    default: null,
});

// Employee form data
export const businessGiftFormState = atom({
    key: 'businessGiftForm',
    default: {
        employeeName: '',
        employeeEmail: '',
    },
});

// Uploaded images for business gift
export const businessGiftImagesState = atom({
    key: 'businessGiftImages',
    default: [],
});

// Selected frame type
export const businessGiftFrameState = atom({
    key: 'businessGiftFrame',
    default: 'classic',
});

// Loading/submitting state
export const businessGiftLoadingState = atom({
    key: 'businessGiftLoading',
    default: {
        fetchingCampaign: false,
        uploadingImage: false,
        submitting: false,
    },
});

// Submission result
export const businessGiftSubmissionResultState = atom({
    key: 'businessGiftSubmissionResult',
    default: {
        success: false,
        submissionNumber: null,
        error: null,
    },
});

// Error state
export const businessGiftErrorState = atom({
    key: 'businessGiftError',
    default: null,
});

// Edit modal state
export const businessGiftEditModalState = atom({
    key: 'businessGiftEditModal',
    default: {
        visible: false,
        image: null,
        businessCode: '',
    },
});
